// Export all services from this file
export { BaseApiService } from './BaseApiService';
export { TradierService } from './TradierService';
export { FinancialDataService } from './FinancialDataService';
export { NewsService } from './NewsService';
export { FredService } from './FredService';
export { FinnhubNewsService } from './FinnhubNewsService';
export { EnhancedAIAnalysisService } from './EnhancedAIAnalysisService';
export { TechnicalAnalysisService } from './TechnicalAnalysisService';
export { AWSAIAgentService, awsAIAgentService } from './AWSAIAgentService';
export { AIAnalysisCacheService } from './database';

// Import services for singleton instances
import { TradierService } from './TradierService';
import { FinancialDataService } from './FinancialDataService';
import { NewsService } from './NewsService';
import { FredService } from './FredService';

// Service instances - can be imported and used directly (lazy initialization)
let _tradierService: TradierService | null = null;
let _financialDataService: FinancialDataService | null = null;
let _newsService: NewsService | null = null;
let _fredService: FredService | null = null;

export const tradierService = {
  get instance() {
    if (!_tradierService) {
      _tradierService = new TradierService();
    }
    return _tradierService;
  }
};

export const financialDataService = {
  get instance() {
    if (!_financialDataService) {
      _financialDataService = new FinancialDataService();
    }
    return _financialDataService;
  }
};

export const newsService = {
  get instance() {
    if (!_newsService) {
      _newsService = new NewsService();
    }
    return _newsService;
  }
};

export const fredService = {
  get instance() {
    if (!_fredService) {
      _fredService = new FredService();
    }
    return _fredService;
  }
};
